import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_treatment_hdr_RowClass } from '../../../dbschema';

export class DgMktTreatmentHeaderContainerModel extends BaseContainerModel {
  bl_dgmkt_treatment_ext: bl_dgmkt_treatment_hdr_RowClass =
    new bl_dgmkt_treatment_hdr_RowClass();
}
